import React, { Component } from 'react';
import yaml from 'js-yaml';

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import ProductLayout from './ProductLayout'

import '../css/TechPage.css';
import { buildPath } from '../utils/route_utils.js'
import { updateProductSEO } from '../utils/seo_utils'

/*
 * Product detail page shell: loads the product's YAML block and hands it to
 * ProductLayout (stage hero, at-a-glance band, edge-to-edge media rows,
 * video tiles, spec band, related tiles, CTA). The quadruped (odo) is
 * served by OdoPage instead (see App.js).
 */
class TechPage extends Component {

  constructor(props) {
    super(props);

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const pageId = pathParts.length >= 3 ? pathParts[2] : 'beaver';

    this.state = {
      id: pageId,
      lang: this.props.lang,
      tech_page_icon_flag: true,
      tech_page_flag: false,
      tech_page_title: {"en": [], "zh": [], "ja": []},
      tech_page_desc: {"en": [], "zh": [], "ja": []},
      tech_page_img: [],
      web_content: {"": []},
      product: [],
      switch_page_flag: false,
    }

    this.get_data = this.get_data.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    this.get_data(this.state.id)
    updateProductSEO(this.state.id, this.state.lang, '/tech/' + this.state.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    if (win != null) {
      win.focus();
    }
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const lang = this.state.lang;
    const productName = this.state.tech_page_title || { zh: this.state.id, en: this.state.id, ja: this.state.id };
    const breadcrumbItems = [
      { label: { zh: "產品", en: "Products", ja: "製品" }, route: '/solutions' },
      { label: productName }
    ];

    return (
      <div id="body" className={lang + " tech_page"}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={breadcrumbItems} />

        {this.state.tech_page_flag && ProductLayout({
          lang, id: this.state.id, title: this.state.tech_page_title, model: this.state.tech_page_desc,
          content: this.state.web_content, navigate: (route) => this.navigate(route)
        })}

        <Footer lang={lang} navigate={(route) => this.navigate(route)} />
      </div>
    );
  }

  get_data(page_title) {
    fetch(process.env.PUBLIC_URL + '/yaml/product_info.yaml')
      .then(response => response.text())
      .then(text => {
        const tech_content = yaml.load(text)["tech_content"];
        if (!tech_content || !tech_content[page_title]) {
          // Retired or unknown product id: send the visitor to the catalogue.
          window.location.replace(buildPath(this.state.lang, '/solutions'));
          return;
        }
        this.setState({
          tech_page_flag: true,
          tech_page_icon_flag: tech_content[page_title]["tech_page_icon_flag"],
          tech_page_title: tech_content[page_title]["tech_page_title"],
          tech_page_desc: tech_content[page_title]["tech_page_desc"],
          tech_page_img: tech_content[page_title]["tech_page_img"],
          web_content: tech_content[page_title]["web_content"]
        })
      });
  }
}

export default TechPage;
